import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppMessageService {
    private openCartSubject: Subject<any> = new Subject<any>();
    private openSearchSubject: Subject<any> = new Subject<any>();
    private cartItemsChangesSubject: Subject<any> = new Subject<any>();
    private miniCartSubject: Subject<any> = new Subject<any>();
    private resetHeaderSubject: Subject<any> = new Subject<any>();
    private cartItemsCountSubject: Subject<any> = new Subject<any>();
    private wishListSubject: Subject<any> = new Subject<any>();
    private notifyLoginSubject: Subject<any> = new Subject<any>();
    private cookieBannerContent: Subject<any> = new Subject<any>();
    private cookieBannerResponse: Subject<any> = new Subject<any>();
    private miniCartViewSubject: Subject<any> = new Subject<any>();
    private showSearchBox: Subject<boolean> = new Subject<boolean>();
    private collapseMenu: Subject<boolean> = new Subject<boolean>();
    private openMenuFn: Function;
    private siteMapsSubject: Subject<boolean> = new Subject<boolean>();
    private flp360LoginSubject: Subject<boolean> = new Subject<boolean>();
    private showRestrictOrderNotificationSubject: Subject<boolean> = new Subject<boolean>();
    private memberOrderRestrictionInfoSubject: Subject<boolean> = new Subject<boolean>();
    private reigonSelect: Subject<number>= new Subject<number>();
    // intimate whether the body is scrolling automatically
    isBodyScrolling: boolean;
    constructor() { }
    /**
     * Assign method to call
     * @param {Function} fn
     * @memberof AppMessageService
     */
    listenOpenPushMenuFn(fn: Function): void {
        this.openMenuFn = fn;
    }

    /**
     * To get definition of assigned method
     * @returns {Function}
     * @memberof AppMessageService
     */
    getOpenPushMenuFn(): Function {
        return this.openMenuFn;
    }

    setCookieBannerResponseData(data: any): void {
        this.cookieBannerResponse.next(data);
    }

    getCookieBannerResponseData(): Observable<any> {
        return this.cookieBannerResponse.asObservable();
    }
    setCollapseMenu(isOpen: any): void {
        this.collapseMenu.next(isOpen);
      }
      getCollapseMenu(): Observable<boolean> {
        return this.collapseMenu.asObservable();
      }
     /**
     * subject to show/hide search box
     */
    setSearchBoxVisibility(canShow: boolean): void {
        this.showSearchBox.next(canShow);
    }
    isSearchBoxVisibile(): Observable<boolean> {
        return this.showSearchBox;
    }

    /**
     * Data for cookie banner
     */
    setCookieBannerData(data: any): void {
        this.cookieBannerContent.next(data);
    }

    getCookieBannerData(): Observable<any> {
        return this.cookieBannerContent.asObservable();
    }
    /**
     * subject to notify the Login event
     */
    getNotifyLoginStatus(): Observable<any> {
        return this.notifyLoginSubject.asObservable();
    }

    setNotifyLoginStatus(isLogin: boolean): void {
        this.notifyLoginSubject.next(isLogin);
    }
    /**
     * subject to emit isOpen property
     */
    setOpenCart(isOpen: any) {
        this.openCartSubject.next(isOpen);
    }

    /**
     * subject to get isOpen property
     */
    getOpenCart(): Observable<any> {
        return this.openCartSubject.asObservable();
    }

    /**
     * subject to emit isOpen property
     */
    setOpenSearch(isOpen: any) {
        this.openSearchSubject.next(isOpen);
    }

    /**
     * subject to get isOpen property
     */
    getOpenSearch(): Observable<any> {
        return this.openSearchSubject.asObservable();
    }


    /**
    * subject to emit CartItems Changes
    */
    setCartItemsChanges(count: number) {
        this.cartItemsChangesSubject.next(count);
    }

    /**
     * subject to notify when CartItems Changes
     */
    getCartItemsChanges(): Observable<any> {
        return this.cartItemsChangesSubject.asObservable();
    }

    /**
    * set minicart sessionInfo
    */
    setMiniCart(sessionInfo: any) {
        this.miniCartSubject.next(sessionInfo);
    }

    /**
     * get minicart sessionInfo
     */
    getMiniCart(): Observable<any> {
        return this.miniCartSubject.asObservable();
    }

    /**
    * set minicart sessionInfo
    */
    showMiniCartView(val: any) {
        this.miniCartViewSubject.next(val);
    }

    /**
     * get minicart sessionInfo
     */
    getMiniCartView(): Observable<any> {
        return this.miniCartViewSubject.asObservable();
    }


    /**
    * set HeaderData to reset
    */
    setHeaderDataReset() {
        this.resetHeaderSubject.next();
    }

    /**
     *  get HeaderData Reset
     */
    getHeaderDataReset(): Observable<any> {
        return this.resetHeaderSubject.asObservable();
    }

    /**
     * set HeaderData to reset
     */
    setCartItemsCount(count: number) {
        this.cartItemsCountSubject.next(count);
    }

    /**
     *  get HeaderData Reset
     */
    getCartItemsCount(): Observable<number> {
        return this.cartItemsCountSubject.asObservable();
    }

    /**
     * set HeaderData to reset
     */
    setWishListItems() {
        this.wishListSubject.next();
    }

    /**
     *  get HeaderData Reset
     */
    getWishListItems(): Observable<any> {
        return this.wishListSubject.asObservable();
    }

      /**
   * @param  {any} data
   * @returns void
   */
  setSiteMapsSubject(): void {
    this.siteMapsSubject.next();
  }

  /**
   * @returns Observable
   */
  getSiteMapsSubject(): Observable<boolean> {
    return this.siteMapsSubject.asObservable();
  }

    /**
   * @param  {any} data
   * @returns void
   */
    setFlp360LoginSubject(isFlp360LoginClicked: boolean): void {
        this.flp360LoginSubject.next(isFlp360LoginClicked);
    }

    /**
     * @returns Observable
     */
    getFlp360LoginSubject(): Observable<boolean> {
        return this.flp360LoginSubject.asObservable();
    }
    
    /**
     * @returns Observable
     */
    getShowRestrictOrderNotificationSubject(): Observable<boolean> {
        return this.showRestrictOrderNotificationSubject.asObservable();
    }

    /**
     * @param  {any} data
     * @returns void
     */
    setShowRestrictOrderNotificationSubject(): void {
        this.showRestrictOrderNotificationSubject.next();
    }

    /**
       * @param  {any} data
       * @returns void
       */
    setMemberOrderRestrictionInfoSubject(): void {
        this.memberOrderRestrictionInfoSubject.next();
    }

    /**
    * @returns Observable
    */
    getMemberOrderRestrictionInfoSubject(): Observable<boolean> {
        return this.memberOrderRestrictionInfoSubject.asObservable();
    }

    /**
       * @param  {number} reigonSelectID
       * 
       */
      setReigonIdSelect(reigonSelectID:number) {
        this.reigonSelect.next(reigonSelectID);
    }

    /**
    * @returns Observable
    */
   getReigonIdSelect(): Observable<number> {
        return this.reigonSelect.asObservable();
    }



    

}
